import Breadcrumb from "../../../Breadcrumb";

const History = () => {

  return (
   <>
   {/* Breadcrumb */}
   <Breadcrumb />

   This is User History page 
   </>
  );
};

export default History;